interface Return {
    isViisi: () => boolean;
    isAdviesbox: () => boolean;
    isFindesk: () => boolean;
    isFastlane: () => boolean;
    isDefault: () => boolean;
    isProductPropertiesOnly: () => boolean;
}

const useGetEngine = (): Return => {
    const isLocation = (name: string): boolean => window.location.hostname.includes(name);

    const isViisi = (): boolean => isLocation('viisi');

    const isAdviesbox = (): boolean => isLocation('adviesbox');

    const isFindesk = (): boolean => isLocation('findesk');

    const isFastlane = (): boolean => isLocation('fastlane');

    const isDefault = (): boolean => !isViisi() && !isAdviesbox() && !isFindesk() && !isFastlane();

    const isProductPropertiesOnly = (): boolean => isFindesk();

    return {
        isViisi,
        isAdviesbox,
        isFindesk,
        isFastlane,
        isDefault,
        isProductPropertiesOnly,
    };
}

export default useGetEngine;
